module.exports = (__webpack_require__(3))(16);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/UserModel.js from dll-reference girder_lib
// module id = 52
// module chunks = 0